import { useRef, useState } from 'react';
import { clsx } from 'clsx';
import { uuidv4 } from '@hevoio/hevo-ui-toolkit';
import { EntityAction } from '../../interfaces/entity-actions';
import { EntityMenuActionButton } from './EntityMenuActionButton';
import { EntityMenu } from './EntityMenu';

export function EntityMenuActions<A extends string | number | symbol>({
  actions,
  onActionClick,
  className,
  menuLabel,
  menuIconSize
}: {
  actions: EntityAction<A>[];
  onActionClick: (actions: EntityAction<A>) => void;
  className?: string;
  menuLabel?: string;
  menuIconSize?: number;
}) {
  const target = useRef(`menu-actions-${uuidv4()}`);
  const [kebabMenuOpen, setKebabMenuOpen] = useState(false);

  if (actions.length === 0) {
    return null;
  }

  return (
    <>
      <EntityMenuActionButton
        label={menuLabel || 'Actions'}
        target={target.current}
        onClick={() => {
          setKebabMenuOpen(!kebabMenuOpen);
        }}
        className={clsx(className)}
        iconSize={menuIconSize}
      />

      <EntityMenu
        target={target.current}
        open={kebabMenuOpen}
        onClose={() => setKebabMenuOpen(false)}
        placement='bottom-start'
        style={{ top: 20 }}
        actions={actions}
        onActionClick={onActionClick}
      />
    </>
  );
}
